import { CustomButton } from "../../../../../common/components/CustomButton/CustomButton";
import style from "./style.module.scss";
import { AppstoreOutlined, BarsOutlined } from "@ant-design/icons";
import { PublicHolidayList } from "./PublicHolidayList";
import { PublicHolidayCalendar } from "./PublicHolidayCalendar";
import { CustomSegmented } from "../../../../../common/components/Tabs/CustomSegmented";
import { useSearchParams } from "react-router";
import { Suspense, useEffect, useState } from "react";
import { CustomDrawer } from "../../../../../common/components/Drawer/CustomDrawer";
import {
  useHolidayCalendarStore,
  useHolidayStore,
} from "../../store/HolidayStore";
import { DatePicker, Form } from "antd";
import { FormProvider } from "../../../../../common/provider/form/Form.provider";
import { SimpleInput } from "../../../../../common/components/simpleInput";
import { FormatDate } from "../../../../../utilities/formatDate";
import { WorkCalendarService } from "../../core/_request";
import { HttpStatusCode } from "axios";
import dayjs from "dayjs";
import { Loader } from "../../../../../common/components/Loader/Loader";

enum TYPE_VIEW {
  list = "list",
  calendar = "calendar",
}

export const PublicHoliday = () => {
  const [searchParams] = useSearchParams();
  const typeFromURL = searchParams.get("view");

  const [form] = Form.useForm();

  const [isOpenDrawer, setIsOpenDrawer] = useState<boolean>(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { actioned, pageState, setActioned, setPageState } = useHolidayStore();
  const { pageState: pageStateCalendar, setPageState: setPageStateCalendar } =
    useHolidayCalendarStore();

  useEffect(() => {
    if (!isOpenDrawer) {
      form.resetFields();
      setActioned({ action: "no", data: null });
    }
  }, [isOpenDrawer]);

  useEffect(() => {
    if (actioned?.data) {
      getOneHoliday((actioned?.data as any)?.id);
    }
  }, [actioned]);

  const handleOpenDrawer = () => {
    setIsOpenDrawer((prev: boolean) => !prev);
  };

  const getOneHoliday = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await WorkCalendarService.getOneHolyday(id);

      if (res?.status === HttpStatusCode.Ok) {
        console.log(res?.data);
        form?.setFieldsValue({
          ...res?.data,
          date: res?.data?.date ? dayjs(res?.data?.date, "DD/MM/YYYY") : null,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const dataToPost = {
        ...values,
        date: values?.date ? FormatDate.formatDateToPostEn(values?.date) : null,
      };

      if (!values?.id) {
        const res = await WorkCalendarService.createHoliday(dataToPost);
        if (res?.status === HttpStatusCode.Created) {
          handleOpenDrawer();
          if (typeFromURL === TYPE_VIEW.list) {
            setPageState({
              ...pageState,
              page: 1,
            });
          } else {
            setPageStateCalendar({
              ...pageStateCalendar,
              page: 1,
            });
          }

          form.resetFields();
        }
      } else {
        const res = await WorkCalendarService.patchHoliday(dataToPost);
        if (res?.status === HttpStatusCode.Ok) {
          handleOpenDrawer();
          if (typeFromURL === TYPE_VIEW.list) {
            setPageState({
              ...pageState,
              page: 1,
            });
          } else {
            setPageStateCalendar({
              ...pageStateCalendar,
              page: 1,
            });
          }
          form.resetFields();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  const VIEW_TYPE_LIST = [
    {
      value: TYPE_VIEW.calendar,
      icon: <AppstoreOutlined />,
      component: (
        <Suspense fallback={<Loader isLoading />}>
          <PublicHolidayCalendar />
        </Suspense>
      ),
    },
    {
      value: TYPE_VIEW.list,
      icon: <BarsOutlined />,
      component: (
        <Suspense fallback={<Loader isLoading />}>
          <PublicHolidayList onOpenAction={handleOpenDrawer} />
        </Suspense>
      ),
    },
  ];
  return (
    <div>
      <div className={style.holiday__header}>
        <CustomSegmented
          isSetDefaultActive
          items={VIEW_TYPE_LIST}
          tabName="view"
        />
        {typeFromURL === TYPE_VIEW.list && (
          <div className="">
            <DatePicker
              allowClear={false}
              value={dayjs(pageState?.["date[after]"])}
              picker="year"
              onChange={(e) =>
                setPageState({
                  ...pageState,
                  "date[after]": `${dayjs(e).year()}-01-01`,
                  "date[before]": `${dayjs(e).year()}-12-31`,
                })
              }
            />
          </div>
        )}
        <CustomButton
          className="d-flex align-items-center justify-content-center p-2 gap-2"
          style={{
            width: "100px",
          }}
          onClick={handleOpenDrawer}
        >
          Nouveau
        </CustomButton>
      </div>

      <div className="">
        {
          VIEW_TYPE_LIST.find((item: any) => item?.value === typeFromURL)
            ?.component
        }
      </div>

      {isOpenDrawer && (
        <CustomDrawer
          isOpen={isOpenDrawer}
          onClose={handleOpenDrawer}
          title={`${
            actioned?.action === "update" ? "Modification" : "Nouveau"
          }`}
        >
          <Loader isLoading={isLoading} />
          <FormProvider
            Form={Form}
            form={form}
            debug
            onFinish={(values: any) => {
              handleSubmit(values);
            }}
            onFinishFailed={(err) => {
              console.log("err", err);
            }}
          >
            <div className="d-none">
              <SimpleInput Form={Form} name={"id"} label={"ID"} />
            </div>
            <div className="d-flex gap-4">
              <div className="flex-fill">
                <SimpleInput
                  Form={Form}
                  name={"label"}
                  label={"Titre"}
                  //   placeholder={"Titre"}
                  rules={[
                    {
                      required: true,
                      message: "Ce champ est requis",
                    },
                  ]}
                />
              </div>
              <div className="flex-fill">
                <SimpleInput
                  Form={Form}
                  name={"date"}
                  label={"Date"}
                  placeholder={"date"}
                  rules={[
                    {
                      required: true,
                      message: "Ce champ est requis",
                    },
                  ]}
                  customInput={
                    <DatePicker
                      placeholder=""
                      className={"w-100"}
                      showNow={false}
                      format={"DD/MM/YYYY"}
                      allowClear={false}
                    />
                  }
                />
              </div>
            </div>

            <div className="d-flex justify-content-end w-100 mt-4">
              <CustomButton
                type="submit"
                variant="primary"
                isLoading={isLoadingSubmit}
              >
                Enregistrer
              </CustomButton>
            </div>
          </FormProvider>
        </CustomDrawer>
      )}
    </div>
  );
};
